/**
 * 앱 엔트리포인트
 * - index.css: Tailwind base/components/utilities + 전역 리셋 (어드민 포함 공통)
 * - landing.css: 랜딩 페이지 전용 (폼/모달/히어로 등 .fm-*, .hdr, .hero 등)
 *
 * 둘 다 전역으로 로드해야 랜딩과 어드민이 모두 정상 렌더링된다.
 * import 순서 중요: index.css(Tailwind base) → landing.css(override) 순서
 */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles/index.css'
import './styles/landing.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
